/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Card, Col, Container, Dropdown, Form, Row} from 'react-bootstrap';
import TableContainer from 'Common/TableContainer';
import ApiUtils from 'api/ApiUtils';
import {toast} from 'react-toastify';
import ModalContainer from 'Common/ModalContainer';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import Swal from 'sweetalert2';
import {GUEST_STATUS, IS_REQUEST} from 'utils/constant';
import {useDispatch, useSelector} from 'react-redux';
import {setProductIds} from 'slices/statusChange/reducer';
import {changeStatus} from 'slices/thunk';
import GuestForm from './GuestForm';
import moment from 'moment';
import Select, {type SingleValue, type MultiValue} from 'react-select';
import customStyles from 'Common/customStyles';

interface CategoryItemType {
  data: {
    data: [];
    total: number;
  };
  display_header_count: number;
  display_home_count: number;

  message: string;
}

const Guests = (): JSX.Element => {
  document.title = DOCUMENT_TITLE.GUESTS;
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [editGuest, setEditCategory] = useState<any>({});
  const [isEditCatergory, setIsEditCategory] = useState(false);
  const [iseAddCategory, setIsAddCategory] = useState(false);
  const [sortColumn, setSortColumn] = useState('id');
  console.log('🚀 ~ Guests ~ setSortColumn:', setSortColumn);

  const [search, setSearch] = useState<string>('');

  const [sortDirection, setSortDirection] = useState('desc');
  console.log('🚀 ~ Guests ~ setSortDirection:', setSortDirection);
  const [categoryList, setCategoryList] = useState<CategoryItemType>();
  const [venueList, setVenueList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [filter, setFilter] = useState<{
    venue: Array<{value: string; label: string}>;
    event: {value: string; label: string};
  }>({venue: [], event: {value: '', label: ''}});

  console.log('🚀 ~ filter:', filter);

  const [filteredEvent, setFilteredEvent] = useState<{
    value: string;
    label: string;
  } | null>();

  const defaultPage = 1;
  const [pageSize, setPageSize] = useState(50);
  const [pageValue, setPageValue] = useState(defaultPage);
  const [totalRecords, setTotalRecords] = useState(defaultPage);

  const currentData = Math.ceil(totalRecords / pageSize);
  const [allChecked, setAllChecked] = useState(false);
  // const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [isCheckboxChanged, setIsCheckboxChanged] = useState(false);
  const dispatch = useDispatch<any>();
  const [isStatusChange, setisStatusChange] = useState(false);

  const [Checked, seChecked] = useState(false);

  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [modalVideoUrl, setModalVideoUrl] = useState('');
  const [isImage, setIsImage] = useState('');

  const {Layout}: any = useSelector(state => state);
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (Layout.layoutModeType === 'dark') {
      setIsDark(true);
    } else if (Layout.layoutModeType === 'light') {
      setIsDark(false);
    } else {
      setIsDark(false);
    }
  }, [Layout.layoutModeType]);

  const handleVideoClick = (videoUrl: string, Type: string = 'video'): void => {
    setModalVideoUrl(videoUrl);
    setIsImage(Type);
    setIsVideoModalOpen(true);
  };

  const closeModal = (): void => {
    setIsVideoModalOpen(false);
    setModalVideoUrl('');
    setIsImage('');
  };
  // const [resetSearchFlag, setResetSearchFlag] = useState(false);

  const requestStatus = IS_REQUEST;

  // useEffect(() => {
  //   const venue = filter.venue.map(venue => venue.value);
  //   const event = filter.event.map(event => event.value);
  //   const payload = {venue_id: venue, event_id: event};
  //   ApiUtils.getGuestList(
  //     `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
  //     payload,
  //   )
  //     .then(async (data: any): Promise<void> => {
  //       setCategoryList(data as CategoryItemType);
  //       setTotalRecords(data?.data?.total);
  //     })
  //     .catch((error: any) => {
  //       toast.error(error.message);
  //     });

  //   setisStatusChange(false);
  //   setAllChecked(false);
  // }, [
  //   pageValue,
  //   isEditCatergory,
  //   iseAddCategory,
  //   pageSize,
  //   search,
  //   isStatusChange,
  //   filter,
  // ]);

  interface Payload {
    venue_id: string[];
    event_id: string[];
  }

  // Define the debounce function
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  // Define the memoized debounced function
  const debouncedFetchGuestList = useCallback(
    debounce(async (payload: Payload) => {
      try {
        const data: any = await ApiUtils.getGuestList(
          `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
          payload,
        );
        setCategoryList(data as CategoryItemType);
        setTotalRecords(data?.data?.total);
      } catch (error: any) {
        toast.error(error.message);
      }

      setisStatusChange(false);
      setAllChecked(false);
    }, 300),
    [pageValue, pageSize, sortColumn, sortDirection, search],
  );

  // Memoize venue and event IDs
  const venueIds = useMemo(
    () => filter.venue.map(venue => venue.value),
    [filter.venue],
  );
  const eventIds = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    return filter?.event && filter.event.value !== ''
      ? [filter.event.value]
      : [];
  }, [filter.event]);

  // Memoize the payload
  const payload = useMemo(
    () => ({venue_id: venueIds, event_id: eventIds}),
    [venueIds, eventIds],
  );

  useEffect(() => {
    // Call the debounced function with the payload
    debouncedFetchGuestList(payload);
  }, [
    payload,
    pageValue,
    pageSize,
    sortColumn,
    sortDirection,
    search,
    isEditCatergory,
    iseAddCategory,
    isStatusChange,
  ]);

  console.log(
    'result',
    'Event List:',
    eventList,
    'Filter Event:',
    filter.event,
  );

  // Filter out items not present in the event list

  useEffect(() => {
    // const updatedFilterEvent = filter.event.filter((filterItem: any) =>
    //   eventList.some((eventItem: any) => eventItem.value === filterItem.value),
    // );
    // console.log('🚀 ~ useEffect ~ updatedFilterEvent:', updatedFilterEvent);
    // setFilter(prevFilter => ({
    //   ...prevFilter,
    //   event: [...updatedFilterEvent],
    // }));
  }, []);

  // Add a new function to handle normal search
  const handleSearch = (value: string): void => {
    setSearch(value);
    setPageValue(defaultPage);
  };

  const handleNextPagination = (pageSize: any): void => {
    if (currentData > 0 && currentData > pageSize) {
      setPageValue(pageSize + 1);
    }
  };
  const handlePrevPagination = (pageSize: any): void => {
    if (pageSize > 1 && currentData >= pageSize) {
      setPageValue(pageSize - 1);
    }
  };

  // const handleSortByColumn = (column: string): void => {
  //   let newSortDirection = 'asc';

  //   if (column === sortColumn) {
  //     newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
  //   } else {
  //     newSortDirection = 'desc';
  //   }
  //   ApiUtils.getCategoryList(
  //     `?page=${pageValue}&page_size=${pageSize}&sort_column=${column}&sort_direction=${newSortDirection}`,
  //   )
  //     .then(async (data: any): Promise<void> => {
  //       setCategoryList(data as CategoryItemType);
  //       setSortDirection(newSortDirection);
  //       setSortColumn(column);

  //       setTotalRecords((data as CategoryItemType)?.data?.total);
  //     })
  //     .catch((error: any) => {
  //       toast.error(error.message);
  //     });
  // };
  // const toggleCategoryStatus = async (
  //   id: number,
  //   statusId: number,
  // ): Promise<void> => {
  //   // Function to toggle category status

  //   try {
  //     // Implement logic to toggle category status
  //     await ApiUtils.updateCategory({id, status_id: statusId});

  //     ApiUtils.getCategoryList(
  //       `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
  //     )
  //       .then(async (data: any): Promise<void> => {
  //         setCategoryList(data as CategoryItemType);
  //         setTotalRecords((data as CategoryItemType)?.data?.total);
  //       })
  //       .catch((error: any) => {
  //         toast.error(error.message);
  //       });
  //   } catch (error) {
  //     console.error('Error toggling category status:', error);
  //   }
  // };

  // const handleSelectAll = (): void => {
  //   if (allChecked) {
  //     setAllChecked(false);
  //   } else {
  //     setAllChecked(true);
  //   }
  // };
  useEffect(() => {
    if (allChecked) {
      const allIds: any = categoryList?.data?.data?.map(
        (item: {id: any}) => item.id,
      ); // Select all by their IDs
      setSelectedProductIds(allIds);
    } else {
      if (!Checked) {
        setSelectedProductIds([]);
      }
    }
  }, [allChecked, categoryList]);

  // const handleCheckboxChange = (productId: number): void => {
  //   let updatedSelectedProductIds: number[] = [];

  //   if (selectedProductIds.includes(productId)) {
  //     // Uncheck child, remove it from the array
  //     updatedSelectedProductIds = selectedProductIds.filter(
  //       id => id !== productId,
  //     );
  //   } else {
  //     // Check child, add it to the array
  //     updatedSelectedProductIds = [...selectedProductIds, productId];
  //   }

  //   setSelectedProductIds(updatedSelectedProductIds);
  // };

  // useEffect(() => {
  //   dispatch(setProductIds(selectedProductIds));
  //   if (selectedProductIds.length > 0) {
  //     setIsCheckboxChanged(true);
  //   } else {
  //     setIsCheckboxChanged(false);
  //   }
  // }, [selectedProductIds]);
  useEffect(() => {
    dispatch(setProductIds(selectedProductIds));
    if (selectedProductIds.length > 0) {
      setIsCheckboxChanged(true);
    } else {
      setIsCheckboxChanged(false);
    }
    const categorylength: any = categoryList?.data?.data?.length;

    if (selectedProductIds.length === categorylength) {
      setAllChecked(true);
      seChecked(false);
    }
    if (selectedProductIds.length < categorylength) {
      setAllChecked(false);
      seChecked(true);
    }
  }, [selectedProductIds]);

  const productIds = useSelector(
    (state: any) => state.statusChange.setProductids,
  );
  const setproductstatus = async (e: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Want to change status for selected Guests',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    });
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      dispatch(changeStatus(e.target.value, productIds, 'category'));
      setisStatusChange(true);
    }
  };
  useEffect(() => {
    setAllChecked(false);
    setSelectedProductIds([]);
  }, [isStatusChange]);
  const columns = [
    // {
    //   id: 'parentBox', // Give the column a unique ID
    //   Header: () => (
    //     <input
    //       className="parentCheckbox"
    //       type="checkbox"
    //       checked={allChecked} // This binds the checked state to `allChecked`
    //       value="0"
    //       onChange={() => {
    //         handleSelectAll();
    //       }}
    //     />
    //   ),
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: '',
    //   Cell: (cell: any) => {
    //     return (
    //       <div className="d-inline-flex align-items-center gap-3">
    //         <input
    //           className={
    //             selectedProductIds.includes(cell.row.original.id)
    //               ? 'checked-class'
    //               : 'unchecked-class'
    //           }
    //           value={cell.row.original.id}
    //           type="checkbox"
    //           checked={selectedProductIds.includes(cell.row.original.id)}
    //           onChange={() => {
    //             handleCheckboxChange(cell.row.original.id);
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      id: 'guestName',
      Header: 'Guest Name',
      disableFilters: true,
      filterable: true,
      accessor: '',
      Cell: (cell: any) => {
        return (
          <div className="d-flex flex-column">
            {/* Top row: User and Badge */}
            <div className="d-flex align-items-center">
              <span
                className={`badge ${
                  cell.row.original.is_request === 1
                    ? 'bg-primary'
                    : 'bg-secondary'
                } me-2`}
                style={{fontSize: '0.75rem', padding: '2px 6px'}} // Small badge styling
              >
                {cell.row.original.is_request === 1 ? 'New' : 'Existing'}
              </span>
              <div className="user fw-bold">
                {cell.row.original.first_name} {cell.row.original.last_name}
              </div>
            </div>

            {/* Guest details under the user */}
            <div className="guest-details ms-4 mt-1">
              {cell.row.original.guest_detail?.map(
                (guest: any, index: number) => (
                  <div key={index} className="guest-name">
                    {guest?.name}
                    {Boolean(guest?.is_confirm) && (
                      <span
                        className={`badge ms-2 my-1 ${
                          guest?.is_confirm === 1
                            ? 'bg-warning'
                            : guest?.is_confirm === 2
                              ? 'bg-success'
                              : 'bg-danger'
                        }`}>
                        {
                          GUEST_STATUS.find(
                            status => status?.id === guest?.is_confirm,
                          )?.title
                        }
                      </span>
                      // <span
                      //   className={`badge ms-2 ${
                      //     cell.row.original?.status !== 2
                      //       ? 'bg-warning'
                      //       : cell.row.original?.status === 2
                      //         ? 'bg-success'
                      //         : 'bg-danger'
                      //   }`}>
                      //   {
                      //     GUEST_STATUS.find(
                      //       status => status?.id === cell.row.original?.status,
                      //     )?.title
                      //   }
                      // </span>
                    )}
                  </div>
                ),
              )}
            </div>
          </div>
        );
      },
    },
    {
      Header: 'Event',
      disableFilters: true,
      filterable: true,
      accessor: 'event_file', // Assuming 'image' is the property in your data for the image URL
      Cell: ({cell}: any) => {
        return (
          <React.Fragment>
            {(() => {
              const file = cell.row.original.event_file;
              const isImage = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i.test(file);
              const isVideo = /\.(mp4|webm|ogg|mov|avi|flv|mkv)$/i.test(file);

              if (isImage) {
                return (
                  <img
                    src={cell.value}
                    width={60}
                    height={60}
                    alt="Player"
                    onClick={() => handleVideoClick(cell.value, 'image')}
                  />
                );
              } else if (isVideo) {
                return (
                  <div
                    style={{
                      cursor: 'pointer',
                      fontSize: '24px',
                      color: 'white',
                      backgroundColor: 'black',
                      padding: '10px',
                      textAlign: 'center',
                      // borderRadius: '100%',
                    }}
                    onClick={() => handleVideoClick(cell.value)}>
                    ▶
                  </div>
                );
              } else {
                return '-';
              }
            })()}
          </React.Fragment>
        );
      },
    },

    {
      Header: 'Event Name',
      disableFilters: true,
      filterable: true,
      accessor: 'event_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Venue Name',
      disableFilters: true,
      filterable: true,
      accessor: 'venue_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Event Date',
      disableFilters: true,
      filterable: true,
      accessor: 'event_date_time',
      Cell: (cellProps: any) => {
        return moment(cellProps.value).format('Do MMM, YYYY hh:mm A');
      },
    },
    {
      Header: 'Guest list close time',
      disableFilters: true,
      filterable: true,
      accessor: 'guest_close_date_time',
      Cell: (cellProps: any) => {
        return moment(cellProps.value).format('Do MMM, YYYY hh:mm A');
      },
    },
    {
      Header: 'Phone Number',
      disableFilters: true,
      filterable: true,
      accessor: 'phone',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: `Event Type`,
      disableFilters: true,
      filterable: true,
      accessor: 'event_type',
      Cell: (cellProps: any) => {
        return cellProps.value === 1
          ? 'Club'
          : cellProps?.value === 2
            ? 'Restaurant'
            : '-';
      },
    },

    // {
    //   Header: 'Status',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'status_id',
    //   Cell: ({cell}: {cell: {value: number}}) => {
    //     const status = statusList.find(
    //       (status: any): any => cell.value === status?.id,
    //     );

    //     return (
    //       <span
    //         className={`badge text-uppercase ${
    //           status?.id === variables.CATEGORY_ACTIVE_STATUS_ID
    //             ? 'bg-success-subtle text-success'
    //             : 'bg-danger-subtle text-danger'
    //         }`}>
    //         {status?.id === variables.CATEGORY_ACTIVE_STATUS_ID
    //           ? variables.CATEGORY_ACTIVE_STATUS
    //           : variables.CATEGORY_INACTIVE_STATUS}
    //       </span>
    //     );
    //   },
    // },

    {
      Header: 'Status',
      disableFilters: true,
      filterable: true,
      accessor: 'is_request',
      Cell: (cellProps: any) => {
        const guestStatus = requestStatus.find(
          status => status?.id === cellProps?.row?.original?.status,
        );

        return (
          <div className="form-check form-switch d-flex gap-1">
            {guestStatus?.title}
          </div>
        );
      },
    },

    {
      Header: 'Action',
      disableFilters: true,
      filterable: true,
      accessor: (cellProps: any) => {
        return (
          <Dropdown className="text-start">
            <Dropdown.Toggle className="btn btn-ghost-primary btn-icon btn-sm arrow-none">
              <i className="mdi mdi-dots-horizontal" />
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul" className="dropdown-menu-end">
              <li>
                <Dropdown.Item
                  onClick={() => {
                    setEditCategory(cellProps);
                    modalToggle();
                  }}>
                  <i className="ri-pencil-fill align-bottom me-2 text-muted" />{' '}
                  Update Guest Status
                </Dropdown.Item>
              </li>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
  ];

  function modalToggle(): void {
    setModalFlag(!modalFlag);
  }

  useEffect(() => {
    ApiUtils.getVenueList(
      `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}&type=dropDown`,
    )
      .then(async (data: any): Promise<void> => {
        const mappedData = data?.map((data: any) => {
          return {value: data.id, label: data.name};
        });
        setVenueList(mappedData);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });
    // void fetchStatus();
    setisStatusChange(false);
    setAllChecked(false);
  }, []);

  const handleSelectVenueChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    // setFilter(prevFilter => ({
    //   ...prevFilter,
    //   event: [...updatedFilterEvent],
    // }));
    setFilter(prevFilter => ({
      ...prevFilter, // Preserve other properties
      venue: [...selectedOptions], // Update venue
    }));
  };

  const handleSelectEventChange = (
    selectedOption: SingleValue<{value: string; label: string}>,
  ): any => {
    setFilter((prev: any) => ({
      ...prev,
      event: selectedOption,
    }));
  };

  useEffect(() => {
    const mappedFilter = filter?.venue?.map((venue: any) => venue?.value);
    console.log('Inside filter useEffect:', filter);
    try {
      ApiUtils.getEventListByVenue(
        `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}&type=dropDown`,
        mappedFilter,
      )
        .then(async (data: any): Promise<void> => {
          const formattedData = data?.data?.map((event: any) => ({
            value: event.id, // Ensure this matches your API structure
            label: event.event_name, // Ensure this matches your API structure
          }));
          setEventList(formattedData ?? []);

          // setTotalRecords((data as CategoryItemType)?.data?.total);
        })
        .catch((error: any) => {
          toast.error(error.message);
        });
    } catch (error) {
      console.error('Error toggling category status:', error);
    }
    // }, [filter]);
  }, [filter.venue, pageValue, pageSize, sortColumn, sortDirection, search]);

  // // useMemo to filter events based on eventList
  // const filteredEvents = useMemo(() => {
  //   console.log('Inside usememo filteredEvents');
  //   return filter.event.filter((filterItem: any) =>
  //     eventList.some((eventItem: any) => eventItem.value === filterItem.value),
  //   );
  // }, [filter.event, eventList]);

  // // useEffect to update the filter state based on the filtered events
  // useEffect(() => {
  //   setFilter(prevFilter => {
  //     // Only update state if filtered events are different
  //     if (filteredEvents.length !== prevFilter.event.length) {
  //       console.log('Inside useEffect with filteredEvents');
  //       return {
  //         ...prevFilter,
  //         event: filteredEvents, // Update event filter
  //       };
  //     }
  //     return prevFilter; // No change to event state if no filter change
  //   });
  // }, [filteredEvents]); // Dependency only on filteredEvents

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (filter.event) {
      const isValid = eventList.some(
        (eventItem: {value: string; label: string}) =>
          eventItem.value === filter.event?.value,
      );

      setFilteredEvent(isValid ? filter.event : null);
    } else {
      setFilteredEvent(null);
    }
  }, [filter.event, eventList]);

  useEffect(() => {
    setFilter((prevFilter: any) => {
      if (
        (filteredEvent != null &&
          filteredEvent.value !== prevFilter.event?.value) ||
        (filteredEvent == null && Boolean(prevFilter.event))
      ) {
        console.log('Inside useEffect with filteredEvent');
        return {...prevFilter, event: filteredEvent};
      }
      return prevFilter;
    });
  }, [filteredEvent]);

  // const handleGuestExport = async (): Promise<void> => {
  //   try {
  //     const response = await ApiUtils.getGuestExport({
  //       event_id: filteredEvent?.value,
  //     });

  //     // Trigger browser download
  //     const blob = new Blob([response as ArrayBuffer], {
  //       type: 'application/vnd.ms-excel',
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = url;

  //     // Optional: dynamic file name
  //     link.setAttribute('download', 'guests.xls');
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error('Error downloading file:', error);
  //   }
  // };

  interface GuestExportResponse {
    data: string;
  }

  const handleGuestExport = async (): Promise<void> => {
    try {
      const response = (await ApiUtils.getGuestExport({
        event_id: filteredEvent?.value,
      })) as GuestExportResponse;
      console.log('🚀 ~ handleGuestExport ~ response:', response);

      const downloadUrl = response?.data;

      // ✅ Open the file in a new tab
      window.open(downloadUrl, '_blank');

      if (downloadUrl !== undefined && downloadUrl.trim() !== '') {
        // const link = document.createElement('a');
        // link.href = downloadUrl;
        // link.setAttribute('download', 'guests.xlsx');
        // document.body.appendChild(link);
        // link.click();
        // link.remove();

        setFilter({
          venue: [],
          event: {value: '', label: ''},
        });
      } else {
        console.error('Download URL not found in response');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return (
    <div className="page-content">
      <Container fluid={true}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Guests</h4>
        </div>
        <div id="couponsList">
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body className="bg-soft-light border border-dashed border-start-0 border-end-0">
                  <Form>
                    <Row className="g-3 justify-content-between1 align-items-center">
                      {/* <Col lg={4}>
                        <div
                          aria-labelledby="category-name-label"
                          className="mb-3">
                          <Form.Label
                            id="category-name-label"
                            htmlFor="category-name">
                            Venue
                          </Form.Label>
                          <Select
                            isMulti
                            id="venue-name"
                            name="venue-name"
                            // value={selectedCategoryOption}
                            // styles={isDark ? colourStyles : {}}
                            // onChange={handleSelectCategoryChange}
                            options={venueList}></Select>
                        </div>
                      </Col> */}

                      <Col lg={3}>
                        <div
                          aria-labelledby="category-name-label"
                          className="mb-3">
                          <Form.Label
                            id="category-name-label"
                            htmlFor="category-name">
                            Venue
                          </Form.Label>
                          <Select
                            isMulti
                            className="custom-select"
                            id="venue-name"
                            name="venue-name"
                            value={filter.venue}
                            onChange={handleSelectVenueChange}
                            styles={isDark ? customStyles : {}}
                            // styles={isDark ? colourStyles : {}}
                            options={venueList}></Select>
                        </div>
                      </Col>

                      <Col lg={3}>
                        <div
                          aria-labelledby="category-name-label"
                          className="mb-3">
                          <Form.Label
                            id="category-name-label"
                            htmlFor="category-name">
                            Events
                          </Form.Label>
                          <Select
                            className="custom-select"
                            id="event-name"
                            name="event-name"
                            value={filter.event}
                            styles={isDark ? customStyles : {}}
                            // value={selectedCategoryOption}
                            // styles={isDark ? colourStyles : {}}
                            onChange={handleSelectEventChange}
                            options={eventList}></Select>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <button
                          disabled={filteredEvent === null}
                          type="button"
                          onClick={handleGuestExport}
                          className="btn btn-md bg-success mx-2 text-white">
                          <i className="ri-download-2-fill"> </i>Export
                        </button>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <TableContainer
                    columns={columns ?? []}
                    data={categoryList?.data?.data ?? []}
                    iscustomPageSize={false}
                    handleNextPagination={handleNextPagination}
                    handlePrevPagination={handlePrevPagination}
                    pageValue={pageValue}
                    isBordered={true}
                    customPageSize={pageSize}
                    isGlobalFilter={true}
                    pageSize={pageSize}
                    currentData={currentData}
                    setPageSize={setPageSize}
                    // isAddOptions={true}
                    className="custom-header-css"
                    tableClass="table-centered align-middle table-nowrap mb-0"
                    theadClass="text-muted table-light"
                    SearchPlaceholder="Search Guests..."
                    buttonText="Add Event"
                    onClick={() => {
                      setEditCategory({});
                      modalToggle();
                    }}
                    // sortColumn={sortColumn}
                    // sortDirection={sortDirection}
                    // handleSortByColumn={handleSortByColumn}
                    onSearch={handleSearch}
                    isChangeStatus={isCheckboxChanged}
                    isCategory={true}
                    statusClickevent={setproductstatus}
                    // resetSearchFlag={resetSearchFlag}
                  />
                  <div className="noresult" style={{display: 'none'}}>
                    <div className="text-center">
                      <h5 className="mt-2">Sorry! No Result Found</h5>
                      <p className="text-muted mb-0">
                        We've searched more than 150+ Orders We did not find any
                        orders for you search.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        <ModalContainer
          showModal={modalFlag}
          handleClose={modalToggle}
          modalTitle={
            editGuest.id !== undefined ? 'Update Guest Status' : 'Add Event'
          }
          modalBody={
            <>
              <GuestForm
                handleClose={modalToggle}
                editGuest={editGuest}
                setIsEditCategory={setIsEditCategory}
                setIsAddCategory={setIsAddCategory}
              />
            </>
          }
        />
        <ModalContainer
          showModal={isVideoModalOpen}
          handleClose={closeModal}
          size="md"
          isTemplate={true}
          modalTitle={isImage === 'image' ? 'image' : 'video'}
          modalBody={
            <>
              {isImage === 'image' ? (
                <img
                  src={modalVideoUrl}
                  alt="Event"
                  className="modal-image-preview"
                />
              ) : (
                <video controls className="modal-image-preview">
                  <source src={modalVideoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </>
          }
        />
      </Container>
    </div>
  );
};

export default Guests;
